// extracted by mini-css-extract-plugin
export default {"darkBlock":"DarkBlock_darkBlock__ECR-q"};